import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ExportService } from '../../../_services/shared/export.service';
import { IConfigurableMatTableConfig } from 'src/app/_interfaces/IConfigurableMatTableConfig';

@Component({
    selector: 'wfdss-configurable-mat-table',
    templateUrl: './configurable-mat-table.component.html',
    styleUrls: ['./configurable-mat-table.component.scss'],
    providers: [],
    standalone: false
})
export class ConfigurableMatTableComponent implements OnInit, AfterViewInit {
  @Input() sortDirection: 'asc';
  @Input() sortActive: string;
  @Output() rowClick: EventEmitter<any> = new EventEmitter();
  /** If you want the export button for your table, supply a string describing what is to be downloaded. For screenreaders/508. */
  @Input() showExport: false | string = false;
  @Input() exportPrefix: string;
  @Input() exportSuffix: string;
  /** 
   * @description By default, sortingDataAccessor is used to populate the CSV cells with values. When CSV properties need to differ from the table sorting properties, provide an alternative property accessor here. The underlying sortingDataAccessor used for sorting the table will remain unchanged.
   * @example HTML 
   * <wfdss-configurable-mat-table 
      [CSVExportDataAccessor]="exportDataAccessor" // the object/property function which will populate data cells in the CSV on export
      [sortingDataAccessor]="sortingDataAccessor"> // this one will provide the number/string that the underlying table actually sorts on 
      other directives....>
   * </wfdss-configurable-mat-table>
   * @example TS
   *  sortingDataAccessor = (data: any, property: any)  => {
       switch (property) {
         case "Incident Name": 
          return data.incidentName.toLowerCase();
         case "Size (Acres)":          
          return data.acreage;
         case "Discovery Date/Time": 
          return data.discoveredDate.format("MM/DD/YYYY, HH:mm")
         }
     }
    *  exportDataAccessor = (data: any, property: any)  => {
       switch (property) {
         case "Incident Name": 
           return data.incidentName.toLowerCase();
         case "Size (Acres)":          
           return data.acreage;
         case "Discovery Date/Time": 
           return data.discoveredDate.unix()
         }
     }  
   */
  @Input() downloadCSVExportDataAccessor: (data: any, sortHeaderId: string) => string | number;
  @Input() displayPointerOnHover: boolean = false;
  @Output() tableEvent = new EventEmitter<string>(); // implement custom logic based on different table events

  @ViewChild(MatPaginator, {static: false}) set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('tableFilter', {static: false}) tableFilterInput: ElementRef;

  @Input() fixedLayout: boolean;
  @Input() title: string;
  @Input() dataSource: MatTableDataSource<any>;
  @Input() csvDataColumns: string[];

  @Input() set columnMetaInformationIn(value: IConfigurableMatTableConfig[]) {
    this.cols = value.map((meta) => meta.columnName);
    this.columnMetaInformation = value;
  }

  public cols;
  public columnMetaInformation: IConfigurableMatTableConfig[];

  /**
   * @description user supplied string upon which the table is filtered(via filterPrediacte).
   */
  public filterString = '';
  @Input() showFilter = false;
  @Input() pageIndex = 0;
  @Input() pageSize = 10;
  @Input() sortingDataAccessor: any;
  @Input() filterPredicate: any;
  @Input() filterLabel: string = "Filter"

  constructor(private exportService: ExportService) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.sortingDataAccessor) {
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    if (this.filterPredicate) {
      this.dataSource.filterPredicate = this.filterPredicate;
    }
    this.sort.active = this.sortActive;
    this.sort.direction = this.sortDirection;
    this.dataSource.sort = this.sort;
  }

  clearFilter() {
    this.filterString = '';
    this.applyFilter(this.filterString);
  }

  applyFilter(target: any) {
    const filter = target.trim().toLowerCase();
    this.dataSource.filter = filter;

    this.filterString = target;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.tableEvent.emit('searchComplete');
  }
  onClicked(row){
    if(row.disabled) return;
    this.rowClick.emit(row)
  }

  export() {
    const columnNames = this.columnMetaInformation.map(column => column.columnName);
    let sortingDataAccessor = this.dataSource.sortingDataAccessor;
    if(this.downloadCSVExportDataAccessor){
      this.dataSource.sortingDataAccessor = this.downloadCSVExportDataAccessor
    }
    if (!!this.csvDataColumns && this.csvDataColumns?.length) {
      this.exportService.exportTableData(this.dataSource,  this.csvDataColumns, this.csvDataColumns, this.exportPrefix, this.exportSuffix );
    } else {
      if (columnNames && columnNames[0] === 'Delete') {
        const csvDataColumns = columnNames.splice(0, 1);
      }
      this.exportService.exportTableData(this.dataSource, columnNames, columnNames, this.exportPrefix, this.exportSuffix );
    }
    if(this.downloadCSVExportDataAccessor){ // 
      this.dataSource.sortingDataAccessor = sortingDataAccessor
    }
  }
}
